import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import dorianLogo from '../../../../assets/images/dorian2-white.png';
import { CopyrightPolicyContent } from './CopyrightPolicyContent';
import './PrivacyPolicyPage.scss';

export class CopyrightPolicyPage extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  render() {
    return (
      <div className="privacy-policy-page">
        <Container className="">
          <div className="logo">
            <img src={dorianLogo} alt="Dorian" />
          </div>
          <h2 className="privacy-policy-page-title">COPYRIGHT POLICY</h2>
          <CopyrightPolicyContent type="external" />
        </Container>
      </div>
    );
  }
}
